import styled from "styled-components";

export const Container = styled.div``;

export const Text = styled.p`
	font-weight: bold;
	font-size: 1rem;
	text-align: center;
	margin: 0;
`;

export const AreaFooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	justify-content: center;
	width: 100%;

	> button {
		margin: 0;
		padding: 0.4rem 0.2rem;
	}
`;
